import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var defaultColor = 'transparent';

var getPseudoElementStyles = function getPseudoElementStyles(args) {
  var borderEdgeValue = args.borderEdgeValue,
      styles = _objectWithoutProperties(args, ["borderEdgeValue"]);

  return Object.assign({
    content: '""',
    position: 'absolute',
    borderStyle: 'solid',
    pointerEvents: 'none',
    top: borderEdgeValue,
    right: borderEdgeValue,
    bottom: borderEdgeValue,
    left: borderEdgeValue
  }, styles);
};
/**
 * Returns style object that can be used for styling components on focus state.
 * NOTE: the element where this is used needs to have relative positioning so that the
 * pseudo elements created on focus can be properly positioned.
 */


var getBorderFocusStyles = function getBorderFocusStyles(args) {
  var sv = args.siteVariables;
  var _args$borderWidth = args.borderWidth,
      borderWidth = _args$borderWidth === void 0 ? sv.borderWidth : _args$borderWidth,
      _args$borderRadius = args.borderRadius,
      borderRadius = _args$borderRadius === void 0 ? sv.borderRadius : _args$borderRadius,
      _args$focusInnerBorde = args.focusInnerBorderColor,
      focusInnerBorderColor = _args$focusInnerBorde === void 0 ? sv.focusInnerBorderColor || defaultColor : _args$focusInnerBorde,
      _args$focusOuterBorde = args.focusOuterBorderColor,
      focusOuterBorderColor = _args$focusOuterBorde === void 0 ? sv.focusOuterBorderColor || defaultColor : _args$focusOuterBorde,
      borderPadding = args.borderPadding;
  var defaultBorderStyles = {
    borderWidth: borderWidth,
    borderRadius: borderRadius
  };
  return {
    ':focus': {
      outline: 0
    },
    ':focus-visible': {
      borderColor: 'transparent',
      ':before': getPseudoElementStyles(Object.assign({
        zIndex: sv.zIndexes.foreground,
        borderEdgeValue: borderPadding == null ? '0' : "-".concat(borderPadding),
        borderColor: focusInnerBorderColor
      }, defaultBorderStyles)),
      ':after': getPseudoElementStyles(Object.assign({
        zIndex: sv.zIndexes.foreground,
        borderEdgeValue: borderPadding == null ? "-".concat(borderWidth) : "calc(0px - ".concat(borderPadding, " - ").concat(borderWidth, ")"),
        borderColor: focusOuterBorderColor
      }, defaultBorderStyles))
    }
  };
};

export default getBorderFocusStyles;